import {
  get,
  post,
  patch,
  put,
  del,
} from '@/utils/request';

const url = 'course-schedules';

export const scheduleCoverApi = `${url}/covers`;

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function getDisabledDates(store_id = 0) {
  return get({
    url: `${url}/disabled-dates`,
    data: { store_id },
  });
}

export function getDailyCourses({ store_id, report_date }) {
  return get({
    url: `${url}/daily-courses`,
    data: { store_id, report_date: report_date / 1000 },
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

// 根据某张课表生成指定日期范围的课程，若当天对应课程已生成，则不会重复生成
export function generateCourseByCourseScheduleId({ id, start_date, end_date }) {
  return post({
    url: `${url}/${id}`,
    data: { start_date, end_date },
  });
}

// 根据某张课表生成未来一周的课程，若当天对应课程已生成，则不会重复生成
export function generateNextWeekCourses({ id }) {
  return post({
    url: `${url}/${id}/next-week-courses`,
  });
}

export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, update_time) {
  return del({
    url: `${url}/${id}`,
    data: { update_time },
  });
}

export function restore(id, update_time) {
  return put({
    url: `${url}/${id}`,
    data: { update_time },
  });
}
